import { Chip } from '@heroui/react';
import type { ReactNode } from 'react';

interface SelectableChipProps {
  selected: boolean;
  onToggle: () => void;
  children: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Standard toggle chip used for filters and multi-select pickers.
 * Selected → solid amber accent (unmistakable). Unselected → outlined,
 * secondary text that lifts to the accent on hover. Replaces the old
 * `variant={selected ? 'solid' : 'flat'}` pattern whose default-gray
 * selected state was nearly invisible on the dark theme.
 */
export default function SelectableChip({
  selected,
  onToggle,
  children,
  size = 'sm',
  className = '',
}: SelectableChipProps) {
  return (
    <Chip
      size={size}
      variant={selected ? 'solid' : 'bordered'}
      color={selected ? 'primary' : 'default'}
      onClick={onToggle}
      className={[
        'cursor-pointer select-none text-xs transition-all',
        selected
          ? 'font-medium shadow-[0_1px_8px_-2px_var(--accent)]'
          : 'border-[var(--border-em)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:border-[var(--accent)]',
        className,
      ].join(' ')}
    >
      {children}
    </Chip>
  );
}
